import {cleanUrl} from '@jobseeker/lotus/utils';
import Link from 'next/link';
import {useRouter} from 'next/router';

type PillProps = {
  text: string;
  ref?: string;
};

const Pill = (props: PillProps) => {
  const {text} = props;
  const router = useRouter();
  const ref = router.query.ref?.toString() ?? '';

  return (
    <>
      <Link
        href={`/k/${cleanUrl(text)}-jobs?pref=${ref}`}
        style={{
          backgroundColor: 'white',
          borderRadius: '16px',
          marginRight: '8px',
          padding: '4px 8px',
          textDecoration: 'none',
          fontSize: '12px',
          fontWeight: 400,
          color: 'rgb(110, 110, 110)',
          lineHeight: '16px',
          display: 'inline-block',
          marginBottom: '8px',
        }}
        target="_blank"
      >
        {text}
      </Link>
    </>
  );
};

export default Pill;
